export default "__VITE_ASSET__988989c3__"